export default "__VITE_ASSET__BEimPZoy__"